/**
 * Copyright © Veeam Software Group GmbH.
 */

import { BackupAgentRmmProviderModeRepresentation } from '@veeam-vspc/models/web-controllers';

export type EpRmmProviderModes = BackupAgentRmmProviderModeRepresentation;
export const EpRmmProviderModes = BackupAgentRmmProviderModeRepresentation;
